import {computed, ComputedRef} from "vue"
import bookingData from "@/computed/bookingData"
import { ITraveller } from "@/model/Traveller"

const areParticipantNamesFullFilled: ComputedRef<boolean> = computed(()=> {
    let isValid = true
    bookingData.value.travellersArr.forEach((traveller: ITraveller) => {
        if (
            !traveller.getFirstName() ||
            !traveller.getLastName()
        )
            isValid = false
    })
    return isValid
})

export default areParticipantNamesFullFilled